import { render, staticRenderFns } from "./metrics_class_view.vue?vue&type=template&id=21dce4a8&scoped=true&"
import script from "./metrics_class_view.vue?vue&type=script&lang=js&"
export * from "./metrics_class_view.vue?vue&type=script&lang=js&"
import style0 from "./metrics_class_view.vue?vue&type=style&index=0&id=21dce4a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dce4a8",
  null
  
)

export default component.exports